export default __webpack_public_path__ + "static/media/LogoMFRMOIRANS.70990d96.png";